import { onAuthStateChanged, signOut } from "firebase/auth";
import React, { createContext, useCallback, useEffect, useMemo, useReducer, useRef } from "react";
import { auth } from "../config/firebase";
import { CheckUserExist, NewQueryUser } from "../databases/users";

export const AuthContext = createContext({});

const initialState = {
    isLogin : null,
    owndata : {},
    userRole : 0,
    managerRound : null,
}

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_LOGIN":
            return {...state, isLogin : action.payload}
        case "SET_OWNDATA":
            return {...state, owndata : action.payload}
        case "SET_USERROLE":
            return {...state, userRole : action.payload}
        case "SET_MANAGER_ROUND":
            return {...state, managerRound : action.payload}
        default:
            break;
    }
}

export const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    const { isLogin, owndata, userRole, managerRound } = state;
    const setLogin = payload => dispatch({ type: 'SET_LOGIN', payload });
    const setOwndata = useCallback(payload => dispatch({ type : 'SET_OWNDATA', payload }), [])

    const unsub = useRef(null)
    const userSessionTimeout = useRef(null)

    useEffect(() => {
        unsub.current = onAuthStateChanged(auth, async user => {
            if (!user) {
                setLogin(false)
                setOwndata({})
                userSessionTimeout.current = null
                await signOut(auth)
            }
            else {
                setLogin(true)
                const token = await auth.currentUser.getIdTokenResult(true)
                if (!userSessionTimeout.current) {
                    const sessionTimeout = 2 * 60 * 60 * 1000;
                    const expireTime = sessionTimeout - (Date.now() - token.claims.auth_time * 1000)
                    setTimeout(async () => {
                        await signOut(auth).then(() => window.location.reload())
                    }, expireTime);
                }
                
                dispatch({ type : 'SET_USERROLE', payload : token.claims.role || 0 });
                if (token.claims.role === 1) dispatch({ type : 'SET_MANAGER_ROUND', payload : token.claims.round || null });
                const isExists = await CheckUserExist(user.uid)
                if (!isExists) {
                    await signOut(auth)
                    setLogin(false)
                    alert('โปรดลงชื่อเข้าใช้อีกครั้ง')
                }
                else {
                    const res = await NewQueryUser(user.uid)
                    setOwndata({...res})
                }
            }
        })


        return () => {
            setLogin(null);
            setOwndata({});
            if (typeof unsub.current === 'function') unsub.current()
        }
    }, [setOwndata]);
    
    return (
        <AuthContext.Provider value={useMemo(() => ({ isLogin, owndata, setOwndata, userRole, managerRound }), [isLogin, owndata, setOwndata, userRole, managerRound] )}>
            {children}
        </AuthContext.Provider>
    )
}